import React, { Component } from "react";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import history from "../../login/history";
import { trackPromise } from "react-promise-tracker";
import ConfigService from "../../../../services/configuracion/ConfigService";
import Popup from "react-popup";
import InputFile from "../../../generico/InputFile";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import { conveniosImg } from "../../../generico/utils/UrlAPI";
import authService from "../../../../services/login/auth.service";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";


let datosSocio = JSON.parse(sessionStorage.getItem("socio"));
export default class ModificarPaso1 extends Component {
  constructor(props) {
    super(props);
    console.log(history.location.state);
    this.state = this.getInitialState(history.location.state);
    this.onChangedFile = this.onChangedFile.bind(this);
  }

  getInitialState = (subsidio) => ({
    disableSgte: true,
    idSubsidio: +subsidio?.nroSolicitud,
    idClaseSubsidio: +subsidio?.idClaseSubsidio,
    nroCedula: +datosSocio.numeroCedula,
    listaDetalleArchivo: this.getDetalles(subsidio?.nroSolicitud),
    listaDetalle: [],
    nuevoFileCedula: [],
    nuevoFileCertificado: [],
    nuevoFileAnalisis: [],
    nuevoFileAdopcion: [],
  });

  getDetalles = (idSubsidio) => {
    let detalle = [];
    trackPromise(
      SubsidiosService.getArchivosRechazadosSubsidio(idSubsidio)
        .then((response) => {
          let data = JSON.stringify(response.data);
          let jsonData = JSON.parse(data);
          let arrayArchivos = jsonData.datos?.archivos;

          if (response.data.codigo === 0) {
            arrayArchivos.forEach((element, index) => {
              detalle.push({
                id: index,
                nombreArchivo: element.nombreArchivo,
                nroTipo: element.tipoArchivo,
                estado: element.estado === "R" && "Rechazado",
                observaciones: element.observaciones,
                titulo: this.generarTituloLabel(element.tipoArchivo),
                enlace:
                  conveniosImg + element.pathArchivo + element.nombreArchivo,
                archivo: false,
                fileArchivo: undefined,
                extensionArchivo: `${element.nombreArchivo.slice(
                  element.nombreArchivo.length - 3
                )}`,
                imageByteArray:
                  `data:${this.getTypeImage(
                    `${element.nombreArchivo.slice(
                      element.nombreArchivo.length - 3
                    )}`
                  )};base64,` + element.archivo,
              });
            });
            this.setState({ listaDetalle: detalle }, () => {
              console.log(this.state);
            });
          } else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
            return;
          }
        })
        .catch(function (error) {
          authService.logout();
          console.log(error);
        })
    );
    return detalle;
  };

  getTypeImage(tipoArchivo) {
    switch (tipoArchivo) {
      case "png":
        return "image/png";
      case "pdf":
        return "application/pdf";
      default:
        return "image/jpg";
    }
  }

  /*****************************************************************
   *                       TIPOS DE ARCHIVO                        *
   *                             1: CI                             *
   *           2: CERTIFICADO DE NACIMIENTO DEL R. CIVIL           *
   *           5: CERT. DE MATRIMONIO DEL REGISTRO CIVIL           *
   *          13: C. MED. Y REPOSO FORM. CU C/SELLO PROF.          *
   * 21: ESTUDIOS CLINICOS Y LAB. O DOCUMENTOS QUE AVALEN AFECCION *
   *                 7: CONSTANCIA DE INTERNACION                  *
   *           12: SENTENCIA JUDICIAL DE ADOPCION PLENA            *
   *****************************************************************/

  generarTituloLabel(nroTipo) {
    // eslint-disable-next-line default-case
    switch (+nroTipo) {
      case 1:
        return "Adjuntar Nueva Cédula de identidad del solicitante";
      case 2:
        return "Adjuntar Nuevo Certificado de Nacimiento del Registro Civil o Certificado de Nacido Vivo del Ministerio de Salud o muerte fetal";
      case 5:
        return "Adjuntar Nuevo Certificado de Matrimonio y/o Libreta de Familia otorgado por la Dirección General de Registros del Estado Civil";
      case 13:
        return "Adjuntar Nuevo Certificado de Reposo expedido en formulario de reposo proveido por la Cooperativa";
      case 21:
        return "Adjuntar Nuevos Estudios clínicos y laboratoriales u otros documentos que avalen la afección";
      case 7:
        return "Adjuntar Nuevo Certificado de internación en hoja con membrete del sanatorio u hospital";
      case 12:
        return "Adjuntar Nueva Sentencia judicial de adopción plena";
    }
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.create({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  /*********************
   * HANDLE VALIDACION *
   *********************/

  validarArchivos() {
    const numeroArchivos = this.state.listaDetalle.filter(
      (value) => value.archivo === true
    ).length;

    if (numeroArchivos === this.state.listaDetalle.length) {
      this.setState({ disableSgte: false });
    } else {
      this.setState({ disableSgte: true });
    }
  }

  /****************
   * HANDLE FILES *
   ****************/

  onChangedFile(fileItem, row) {
    let lista = [...this.state.listaDetalle];
    let listaArchivo = [...this.state.listaDetalleArchivo];

    listaArchivo[row.id].fileArchivo = fileItem;
    lista[row.id].archivo = true;

    this.setState(
      {
        listaDetalle: lista,
        listaDetalleArchivo: listaArchivo,
      },
      () => {
        this.validarArchivos();
      }
    );
  }

  /******************************************
   * CONTINUAR -> PREPARAR ARCHIVOS Y ENVIAR *
   ******************************************/

  volverSubsidios = () => {
    history.push(ConfigService.getPathByName("solicitudSubsidios")?.url);
    window.location.reload();
  };

  prepararArchivos() {
    let fileCedula = [];
    let fileCertificado = [];
    let fileAdopcion = [];
    let fileAnalisis = [];
    console.log(this.state);

    this.state.listaDetalleArchivo.forEach((el) => {
      // eslint-disable-next-line default-case
      switch (+el.nroTipo) {
        case 1:
          fileCedula.push(el.fileArchivo);
          break;
        case 2:
          fileCertificado.push(el.fileArchivo);
          break;
        case 5:
          fileCertificado.push(el.fileArchivo);
          break;
        case 13:
          fileCertificado.push(el.fileArchivo);
          break;
        case 21:
          fileAnalisis.push(el.fileArchivo);
          break;
        case 7:
          fileCertificado.push(el.fileArchivo);
          break;
        case 12:
          fileAdopcion.push(el.fileArchivo);
          break;
      }
    });

    this.setState(
      {
        nuevoFileCedula: fileCedula,
        nuevoFileCertificado: fileCertificado,
        nuevoFileAdopcion: fileAdopcion,
        nuevoFileAnalisis: fileAnalisis,
      },
      () => {
        this.sendRequestSubsidio();
      }
    );
  }

  sendRequestSubsidio = () => {
    trackPromise(
      SubsidiosService.modificarArchivosSubsidio(
        this.state.idSubsidio,
        this.state.idClaseSubsidio,
        this.state.nroCedula,
        this.state.nuevoFileCedula,
        this.state.nuevoFileCertificado,
        this.state.nuevoFileAnalisis,
        this.state.nuevoFileAdopcion
      ).then((response) => {
        let data = JSON.stringify(response.data);
        let jsonData = JSON.parse(data);
        console.log(data);

        if (+jsonData.codigo === 0) {

          let cantidadArchivos = this.state.nuevoFileCedula.length + this.state.nuevoFileCertificado.length + this.state.nuevoFileAnalisis.length + this.state.nuevoFileAdopcion.length;

          this.props.respuestaPaso1(cantidadArchivos, history.location.state);
          this.nextStep.click();
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
  };

  preventDefault = (e) => {
    e.preventDefault();
  };

  render() {
    if (this.state.listaDetalle.length === 0) return <span></span>;
    return (
      <div>
        <div className="row">
          <div className="steps step-doc clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 float-right">
            {this.state.listaDetalle.map((el) => {
              return (
                <InputFile
                  key={el.id}
                  onChangedFile={this.onChangedFile}
                  rowItem={el}
                  listInputs={this.state.listaDetalle}
                />
              );
            })}
          </div>
        </div>
        <hr />
        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-6">
            <label className="input-label-bold-obligatorio">
              (*) Campos Obligatorios
            </label>
          </div>
          <div className="col-lg-2 col-md-3">
          <button
              className="btn btn-cu-quintary"
              style={{ marginRight: "5px" }}
              onClick={this.volverSubsidios}
            >
             <FontAwesomeIcon icon={faArrowLeft} /> Volver al Listado
            </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button
              disabled={this.state.disableSgte}
              className="btn btn-cu-primary float-right"
              onClick={() => {
                this.prepararArchivos();
              }}
            >
               Continuar <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
          </div>
        </div>

      </div>
    );
  }
}
